export { HttpDirect } from './http-direct';
export { InterceptorModule } from './interceptor.module';
export { InterceptorRequestBuilder } from './interceptor-request-builder';
export { InterceptorRequestOptionsArgs } from './interceptor-request-options-args';
export { InterceptorRequest } from './interceptor-request';
export { InterceptorResponseWrapperBuilder } from './interceptor-response-wrapper-builder';
export { InterceptorResponseWrapper } from './interceptor-response-wrapper';
export { InterceptorService } from './interceptor-service';
export { InterceptorUtils } from './interceptor-utils';
export { Interceptor } from './interceptor';
export { RealResponseObservableTransformer } from './real-response-observable-transformer';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
